// ─── Referral & Ad Revenue Configuration ─────────────────────────────────────
// Update the URLs below with your personal referral/affiliate links.
// Set ADSENSE_CLIENT to your Google AdSense publisher ID (ca-pub-XXXXXXXXXXXXXXXX).
// Ad slots won't render if ADSENSE_CLIENT is empty.

export const ADSENSE_CLIENT = ''; // e.g. 'ca-pub-1234567890123456'

// Ad unit slot IDs from your AdSense account (Ad units → get code → data-ad-slot)
export const AD_SLOTS = {
  // Leaderboard (728×90) — best below hero / above rankings
  leaderboard: '',      // e.g. '1234567890'
  // Rectangle (300×250) — best between content sections
  rectangle: '',        // e.g. '0987654321'
  // In-article — best inside player profile
  inArticle: '',        // e.g. '1122334455'
};

// ─── Partner referral links ───────────────────────────────────────────────────
// Replace '#' with your personal affiliate / referral URL for each platform.
// Leave as '#' to hide that platform (it won't render if href === '#').
export const PARTNERS = [
  {
    id: 'draftkings',
    label: 'DraftKings',
    tagline: 'Daily Fantasy',
    href: '#',           // e.g. 'https://www.draftkings.com/r/YOUR_CODE'
    bg: 'bg-[#1a9f4b]',
    text: 'text-white',
  },
  {
    id: 'fanduel',
    label: 'FanDuel',
    tagline: 'Fantasy & Betting',
    href: '#',           // e.g. 'https://www.fanduel.com/join?pid=YOUR_PID'
    bg: 'bg-[#1493ff]',
    text: 'text-white',
  },
  {
    id: 'prizepicks',
    label: 'PrizePicks',
    tagline: 'Player Props',
    href: '#',           // e.g. 'https://app.prizepicks.com/sign-up?inviteCode=YOUR_CODE'
    bg: 'bg-[#5f3dc4]',
    text: 'text-white',
  },
  {
    id: 'underdog',
    label: 'Underdog',
    tagline: 'Best Ball & Props',
    href: '#',           // e.g. 'https://underdogfantasy.com/referral/YOUR_CODE'
    bg: 'bg-[#f97316]',
    text: 'text-white',
  },
  {
    id: 'espn',
    label: 'ESPN Fantasy',
    tagline: 'Season-Long',
    href: '#',           // e.g. 'https://fantasy.espn.com/basketball'
    bg: 'bg-[#cc0000]',
    text: 'text-white',
  },
  {
    id: 'yahoo',
    label: 'Yahoo Fantasy',
    tagline: 'Season-Long',
    href: '#',           // e.g. 'https://sports.yahoo.com/fantasy/basketball'
    bg: 'bg-[#6001d2]',
    text: 'text-white',
  },
];

// Active partners — those with a real href (not '#')
export const activePartners = () => PARTNERS.filter((p) => p.href !== '#');
